import { I18n } from '@calendly/i18n';
import classNames from 'classnames';
import { forwardRef } from 'react';
const wrapperCss = "wpmikai";
const Wrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(wrapperCss, props.className)} />;
});
const cellCss = "cuhk0c9";
const Cell = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(cellCss, props.className)} />;
});
const textCss = "t2y9yb3";
const Text = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'p';
  return <Component ref={ref} {...restProps} className={classNames(textCss, props.className)} />;
});
export const UserGroupInfo = ({
  userGroup
}) => <Wrapper>
    <Cell>
      <Text>{userGroup.name}</Text>
    </Cell>
    <Cell>
      <Text>
        {I18n.t('publisher.organization.managed_event_types.assign.add_groups.user_group_members_count', {
        count: userGroup.user_group_relationships_count
      })}
      </Text>
    </Cell>
  </Wrapper>;

require("./user_group_info.wyw-in-js.css!=!../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./user_group_info.js");